/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Region_CervicalInputs */

const en_us2_bodymap_region_cervical = /** @type {(inputs: Bodymap_Region_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neck`)
};

const pt_br2_bodymap_region_cervical = /** @type {(inputs: Bodymap_Region_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pescoço`)
};

const es_419_bodymap_region_cervical = /** @type {(inputs: Bodymap_Region_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuello`)
};

const pt_pt2_bodymap_region_cervical = /** @type {(inputs: Bodymap_Region_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pescoço`)
};

const fr_fr2_bodymap_region_cervical = /** @type {(inputs: Bodymap_Region_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cou`)
};

const de_de2_bodymap_region_cervical = /** @type {(inputs: Bodymap_Region_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacken`)
};

const it_it2_bodymap_region_cervical = /** @type {(inputs: Bodymap_Region_CervicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collo`)
};

/**
* | output |
* | --- |
* | "Neck" |
*
* @param {Bodymap_Region_CervicalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_region_cervical = /** @type {((inputs?: Bodymap_Region_CervicalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Region_CervicalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_region_cervical(inputs)
	if (locale === "es-419") return es_419_bodymap_region_cervical(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_region_cervical(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_region_cervical(inputs)
	if (locale === "de-DE") return de_de2_bodymap_region_cervical(inputs)
	if (locale === "it-IT") return it_it2_bodymap_region_cervical(inputs)
	return en_us2_bodymap_region_cervical(inputs)
});
export { bodymap_region_cervical as "bodymap.region.cervical" }